import { Component, OnDestroy, OnInit } from "@angular/core";
import { BaseDetailsLogic } from "app/analytics/BaseDetailsLogic";
import {
  AnalyticsService,
  AuthorizationService,
  ExpirationTimePeriod,
  LoggingService,
  TimePeriod,
  UserPermissions,
} from "app/shared";
import { UsersTotalConfig } from "app/shared/model/charts/user-analytic-configurations.model";
import { TooltipCoordinatorService } from "app/analytics/services/tooltip-coordinator.service";

@Component({
  selector: "users-total-details",
  templateUrl: "./users-total-details.component.html",
  standalone: false,
})
export class UsersTotalDetailsComponent
  extends BaseDetailsLogic<UsersTotalConfig>
  implements OnInit, OnDestroy
{
  constructor(
    analyticsService: AnalyticsService,
    authService: AuthorizationService,
    loggingService: LoggingService,
    tooltipCoordinator: TooltipCoordinatorService
  ) {
    super(analyticsService, authService, loggingService, UsersTotalConfig, tooltipCoordinator);
  }

  //TODO: Analytics:  Add TimePeriod select for sessionExpirationPeriod, see manuals-downloaded-details.component.ts and html, also add to html

  get selectedTimePeriod(): string | TimePeriod {
    return this.config?.period as TimePeriod;
  }

  set selectedTimePeriod(value: string | TimePeriod) {
    this.config.period = value;
    this.detectSettingsChange();
    this.refreshDataFromFilters();
  }

  get selectedPermission(): number | UserPermissions {
    return this.config.userPermission as UserPermissions;
  }

  set selectedPermission(value: number | UserPermissions) {
    this.config.userPermission = value;
    this.detectSettingsChange();
    this.refreshDataFromFilters();
  }

  public localSelectedChartType: string = "";

  protected override onConfigReady(): void {
    this.localSelectedChartType = this.config?.generalSettings?.chartType || "";
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }

  protected getInfoTexts(): { [key: string]: string } {
    return {
      timePeriod:
        "Pick a time period to see the total number of users during that time. For example, you can look at the total users in the last week, month, or year. This helps you understand how your user base changes over time.",
      userPermission:
        "Select the type of user permission to filter results. This helps you focus on the activity of specific user groups.",
      increments:
        "Shows the spacing between each point on the line chart's X-axis. For example, if increments are set to 'Day', each point represents a day. This helps you understand the time step between data points.",
    };
  }
}
